import apiInternal from './servers/apiInternal';

export interface CapsolverConsumo {
  success: boolean;
  balance: number | null;
  error: string | null;
}

export interface NopechaData {
  plan: string;
  status: string;
  credit: number;
  quota: number;
  duration: number;
  lastreset: number;
  ttl: number;
  subscribed: number;
  current_period_start: number;
  current_period_end: number;
}

export interface NopechaConsumo {
  success: boolean;
  data: NopechaData | null;
  error: string | null;
}

export interface CapmonsterConsumo {
  success: boolean;
  balance: number | null;
  error: string | null;
}

export interface WebshareAggregateData {
  bandwidth_projected: number;
  bandwidth_total: number;
  bandwidth_average: number;
  requests_total: number;
  requests_successful: number;
  requests_failed: number;
  number_of_proxies_used: number;
  average_concurrency: number;
  average_rps: number;
}

export interface WebshareStatData {
  timestamp: string;
  is_projected: boolean;
  bandwidth_total: number;
  bandwidth_average: number;
  requests_total: number;
  requests_successful: number;
  requests_failed: number;
  number_of_proxies_used: number;
  average_concurrency: number;
  average_rps: number;
  last_request_sent_at?: string;
}

export interface WebshareConsumo {
  success: boolean;
  data: {
    aggregate: WebshareAggregateData;
    stats: WebshareStatData[];
  } | null;
  error: string | null;
}

export interface DataImpulseConsumo {
  success: boolean;
  data: {
    bandwidth_total: number;
    bandwidth_used: number;
    bandwidth_available: number;
    used_threads: number;
    login: string | null;
    status: string | null;
    message: string | null;
    elapsed: string | null;
  } | null;
  error: string | null;
}

export interface BrightDataConsumo {
  success: boolean;
  data: {
    bandwidth_total: number;
    bandwidth_used: number;
    bandwidth_available: number;
    balance: number;
    account_id: string | null;
    status: string | null;
    [key: string]: any;
  } | null;
  error: string | null;
}

export interface ConsumosResponse {
  success: boolean;
  data: {
    capsolver: CapsolverConsumo;
    nopecha: NopechaConsumo;
    capmonster: CapmonsterConsumo;
    webshare: WebshareConsumo;
    dataimpulse: DataImpulseConsumo;
    brightdata1: BrightDataConsumo;
    brightdata2: BrightDataConsumo;
  };
}

export interface ConsumosBreakerAlertItem {
  provider: string;
  label: string;
  balance: number;
}

export interface ConsumosProxyAlertItem {
  provider: string;
  label: string;
  bandwidthTotal?: number;
  bandwidthProjected?: number;
  bandwidthAvailable?: number;
}

export interface ConsumosAlertsResponse {
  success: boolean;
  showLowBreakerBalanceAlert: boolean;
  showNoBreakerBalanceAlert: boolean;
  showNoProxyBalanceAlert: boolean;
  lowBalanceBreakers: ConsumosBreakerAlertItem[];
  noBalanceBreakers: ConsumosBreakerAlertItem[];
  noBalanceProxies: ConsumosProxyAlertItem[];
  fromCache?: boolean;
  cachedAt?: string;
  message?: string;
  error?: string;
}

const consumos = {
  getConsumos: async (): Promise<ConsumosResponse> => {
    const res = await apiInternal.get(`/consumos`);
    return res.data;
  },
  getAlerts: async (): Promise<ConsumosAlertsResponse> => {
    const res = await apiInternal.get(`/consumos/alerts`);
    return res.data;
  },
};

export default consumos;
